export const iconFontAwesomeTransportationRoadSpikes = (
	<i className="fa-solid fa-road-spikes"></i>
);
